var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreat3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 424.73 424.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#636154;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.26,113.45c-53.26,0-96.42,43.56-96.42,97.26S161,308,214.26,308s96.38-43.53,96.38-97.25-43.18-97.26-96.38-97.26Zm0,152.92c-30.46,0-55.16-24.94-55.16-55.66s24.7-55.63,55.16-55.63,55.1,24.91,55.1,55.63S244.67,266.37,214.26,266.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.18,0h32.14V79.57H198.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.58,72.4,350.85,49.48,295.1,105.76l22.72,22.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.83,194.91h78.9V227.3H345.84V194.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.38,373.36l22.72-22.92-55.77-56.26-22.71,22.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.84,345.42H231V425H198.84V345.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.63,352.57l22.73,22.94,55.77-56.29-22.69-22.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,197H78.88v32.43H0V197Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.76,49.55,49.08,72.46l55.76,56.26,22.7-22.92Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreat3);
export default __webpack_public_path__ + "static/media/Treat3.926606c8399761441fb2d230b7cf6f58.svg";
export { ForwardRef as ReactComponent };